export default __webpack_public_path__ + "static/media/dingdan.5674eba3.png";